import { Handle, type NodeProps, Position } from "@xyflow/react";
import { memo } from "react";
import { color, font, radius } from "theme/aiInventory";

export type ToolNodeData = {
  name: string;
};

const style: React.CSSProperties = {
  background: color.card,
  border: `1px solid ${color.rule}`,
  borderRadius: radius.card,
  padding: "6px 10px",
  fontFamily: font.mono,
  fontSize: 10,
  color: color.inkDim,
  minWidth: 110,
  textAlign: "left",
  animation: "p0-fade-in 240ms cubic-bezier(.2,.8,.2,1)",
};

export const ToolNode: React.FC<NodeProps> = memo(({ data }) => {
  const typed = data as ToolNodeData;
  return (
    <div style={style}>
      <Handle type="target" position={Position.Left} />
      {typed.name}
      <Handle type="source" position={Position.Right} />
    </div>
  );
});
ToolNode.displayName = "ToolNode";
